import api from '@/services/Api.ts'
type ListObjectType = {
  value: string
  name: string
}
export const getSuperFundNames = async (name = ''): Promise<ListObjectType[]> => {
  const response = await api().Get(`/chant-west/superfunds?search=${name}`)
  if (!response) return []
  const superFunds: ListObjectType[] = []
  Object.keys(response.data).forEach((key) => {
    superFunds.push({
      value: response.data[key].id,
      name: response.data[key].longName,
    })
  })
  return superFunds
}

export const generateOtivoAccountNumber = () => {
  return '07150' + Date.now().toString()
}
